import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { db } from '../firebaseConfig/firebase';
import { collection, query, where, getDocs, doc, updateDoc, writeBatch } from "firebase/firestore";
import { Button, Form, Alert, ProgressBar, Container } from 'react-bootstrap';

import Header from './Header';

function UpdateExp() {

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: '', msg: '' });
    const [progress, setProgress] = useState(0);

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);
        setStatus({ type: 'info', msg: 'Procesando archivo...' });

        const reader = new FileReader();
        reader.onload = async (event) => {
            try {
                const workbook = XLSX.read(event.target.result, { type: 'binary' });
                const sheetName = workbook.SheetNames[0];
                const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

                await updateDatabase(excelData);
            } catch (error) {
                setStatus({ type: 'danger', msg: 'Error al leer el Excel' });
                setLoading(false);
            }
        };
        reader.readAsBinaryString(file);
    };

    const updateDatabase = async (data) => {
        let actualizados = 0;
        let errores = 0;

        let batch = writeBatch(db);
        let count = 0;

        for (let i = 0; i < data.length; i++) {
            const fila = data[i];
            const email = fila.EMAIL_ALUMNO?.trim();
            const nuevaNotaExp = parseFloat(fila.NOTA_EXP) || 0;

            if (!email) continue;

            // 1. Buscar el documento
            const q = query(collection(db, "tribu-esp"), where("EMAIL_ALUMNO", "==", email));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                for (const documento of querySnapshot.docs) {
                    const dataDoc = documento.data();

                    // 2. Obtener las notas existentes (asegurándonos de que sean números)
                    const notaEntrevista = parseFloat(dataDoc.NOTA_ENTREVISTA) || 0;
                    const notaPortfolio = parseFloat(dataDoc.NOTA_PORTFOLIO) || 0;

                    // 3. Calcular la media (Total / 3)
                    const totalCandidato = (nuevaNotaExp + notaEntrevista + notaPortfolio) / 3;

                    // 4. Preparar la actualización
                    const docRef = doc(db, "tribu-esp", documento.id);
                    batch.update(docRef, {
                        NOTA_EXP: String(nuevaNotaExp),
                        TOTAL_CANDIDATO: Number(totalCandidato.toFixed(2)) // Guardamos con 2 decimales
                    });

                    actualizados++;
                    count++;
                }
            } else {
                console.warn(`No se encontró alumno con email: ${email}`);
                errores++;
            }

            // Manejo de batches de Firestore (límite 500)
            if (count >= 400) {
                await batch.commit();
                batch = writeBatch(db);
                count = 0;
            }

            setProgress(Math.round(((i + 1) / data.length) * 100));
        }

        if (count > 0) await batch.commit();

        setStatus({
            type: 'success',
            msg: `Proceso terminado. Actualizados: ${actualizados}. No encontrados: ${errores}`
        });
        setLoading(false);
    };

    return (
        <>
            <Header />
            <Container>
                <div className="p-4 border rounded bg-light mt-4">
                    <h5>Actualizar Notas EXP mediante Excel</h5>
                    <p className="small text-muted">
                        El Excel debe tener las columnas: <strong>EMAIL_ALUMNO</strong> y <strong>NOTA_EXP</strong>
                    </p>

                    <Form.Group className="mb-3">
                        <Form.Control
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={handleFileUpload}
                            disabled={loading}
                        />
                    </Form.Group>

                    {loading && (
                        <div className="mb-3">
                            <p className="small mb-1">Actualizando base de datos... {progress}%</p>
                            <ProgressBar animated now={progress} />
                        </div>
                    )}

                    {status.msg && <Alert variant={status.type}>{status.msg}</Alert>}
                </div>
            </Container>
        </>
    );
};

export default UpdateExp